<div class="page-content page-fill">
  <div class="grid-fill">
    <dx-data-grid #dataGrid [dataSource]="store" (onToolbarPreparing)="onToolbarPreparing($event)" [focusedRowEnabled]="false">
      <dxi-column dataField="subject" cellTemplate="linkTemplate"></dxi-column>
      <div *dxTemplate="let cell of 'linkTemplate'">
        <a [routerLink]="cell.data.id">{{ cell.value || '(blank)' }}</a>
      </div>
      <dxi-column dataField="toGroup.name" caption="To"></dxi-column>
      @if (mode == 'sent') {
        <dxi-column dataField="sent" format="shortDateShortTime" width="200px" [sortIndex]="0" [sortOrder]="'desc'"></dxi-column>
      }
      @if (mode == 'drafts') {
        <dxi-column dataField="created" format="shortDateShortTime" width="200px"></dxi-column>
      }
      @if (mode == 'sent' && appInfo.graafschap) {
        <dxi-column dataField="fromUser.userName" caption="From"></dxi-column>
      }

      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-selection [mode]="'multiple'"></dxo-selection>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="messageGrid"></dxo-state-storing>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <div *dxTemplate="let data of 'toolbarButtons'">
        @if (mode == 'drafts') {
          <button class="btn btn-secondary ms-2" (click)="add()">New</button>
        }
        @if (appInfo.graafschap) {
          <button
            class="btn btn-success ms-2"
            (click)="copy()"
            [disabled]="dataGrid.focusedRowIndex === -1 || dataGrid.instance.getSelectedRowsData().length !== 1"
            >
            Copy
          </button>
        }
        @if (appInfo.graafschap && mode != 'drafts') {
          <button
            class="btn btn-primary ms-2"
            (click)="openSents()"
            [disabled]="dataGrid.focusedRowIndex === -1 || dataGrid.instance.getSelectedRowsData().length !== 1"
            >
            View Sent
          </button>
        }
        @if (mode == 'drafts' && auth.hasRole('Administrator')) {
          <button class="btn btn-danger ms-2" (click)="delete()" [disabled]="dataGrid.focusedRowIndex === -1">
            Delete
          </button>
        }
        @if (appInfo.graafschap && mode !='drafts') {
          <button
            class="btn btn-sm btn-warning ms-2"
            (click)="toggleShowAll()">
            {{ showAll ? 'Show Recent' : 'Show All' }}
          </button>
        }
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (store && mode != 'drafts') {
          <span class="ms-3">
            <strong>
              {{ dataGrid.instance.totalCount() + ' items' }}
            </strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
